/* angular:styles/component:css;dcd32728d8ccd249530c8b0a69339ef91b8189e8d475393f2a71a5e6ed868d70;/codebuild/output/src3156720417/src/smartdineuinew/src/app/common/components/feedback/star-rating/star-rating.component.ts */
.star-rating {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.star-rating ion-icon {
  font-size: 30px;
  color: #95D2B3;
  cursor: pointer;
}
/*# sourceMappingURL=star-rating.component.css.map */
